import React, { useEffect } from "react";
import AboutUsHome from "../../components/AboutUsHome";
import Banner from "../../components/Banner";
import CredentialHome from "../../components/CredentialHome";
import OurBusiness from "../../components/OurBusiness";
import "./Home.css";
export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Banner />
      <CredentialHome />
      <OurBusiness />
      <AboutUsHome />
    </>
  );
}
